import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-block-hash',
  templateUrl: './block-hash.component.html',
  styleUrls: ['./block-hash.component.css']
})
export class BlockHashComponent implements OnInit {
  blockId: any;
  blockDetailsList: any;
  blockHash: any;
  transTime: any;
  timeString: string = '';


  constructor(private spinner : NgxSpinnerService,private conn: ConnectionService,private activatedRoute: ActivatedRoute, private alert: ToastrService) { 
    this.blockHash = this.activatedRoute.snapshot.params['hash'];
  }

  ngOnInit(): void {
    setTimeout(()=>
    {
      this.blockDetails(this.blockHash)
    },1000)
    setTimeout(()=>
    {
      this.calculateTimeRemaining();
    },3000)
  }

  previousBlock(hash?:any){
    this.blockHash = hash
    this.blockDetails(this.blockHash)
  }

  blockDetails(hash:any) {
    this.spinner.show()
    this.conn.postUrl('users/parentHash', { parentHash: hash }).subscribe((res: any) => {
      this.spinner.hide()
      this.blockId = res.data[0].blockID
      this.blockDetailsList = res.data[0].block_header.raw_data
      this.transTime = this.blockDetailsList?.timestamp

    })
  }

  calculateTimeRemaining() {

    const currentTime = new Date().getTime();
    const timeDifference = currentTime - this.blockDetailsList?.timestamp ;
    if (timeDifference > 0) {
      const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
      this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
      setTimeout(() => {
        this.calculateTimeRemaining();
      }, 1000);
    } else {
      // this.timeString = 'Timer expired!';
    }
  }

  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }
}
